import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import FormGroup from 'react-bootstrap/FormGroup';
import FormControl from 'react-bootstrap/FormControl';

import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';
import { formatLocale } from '../../../helpers/formatLocale';

import addIcon from '../../../../public/Icons/plusIcon.svg';
import trashIcon from '../../../../public/Icons/deleteIocn.svg';

import s from './CitySettingsForm.css';
import bt from '../../../components/commonStyle.css';

export class CitySettingsForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedLanguages: []
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { dynamicCategoryTitle } = nextProps;
        let filteredLanguages = dynamicCategoryTitle?.map((item) => { return item?.language })
        this.setState({ selectedLanguages: filteredLanguages });
    }

    renderField = ({ input, label, type, meta: { touched, error }, placeholder, inputClassname }) => {
        const { formatMessage } = this.props.intl
        return (
            <Form.Group className={inputClassname}>
                <label className={bt.labelText} >{label}</label>
                <Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} />
                {touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
            </Form.Group>
        )
    }
    renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
        const { formatMessage } = this.props.intl
        return (
            <div>
                <FormGroup className={s.formGroup}>
                    <div>
                        <label className={bt.labelText} >{label}</label>
                    </div>
                    <div>
                        <FormControl
                            {...input}
                            className={bt.formControlInput}
                            placeholder={label}
                            as="textarea"
                            rows="3"
                        >
                            {children}
                        </FormControl>
                        {touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
                    </div>
                </FormGroup>
            </div>
        );
    }

    renderFormControlSelect = ({ input, meta: { touched, error }, className, children, label }) => {
        const { formatMessage } = this.props.intl;
        return (
            <div className={bt.noMargin}>
                {label && <label className={bt.labelText} >{label}</label>}
                <FormControl as="select" {...input} className={className} >
                    {children}
                </FormControl>
                {touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
            </div>
        )
    }

    renderFieldArray = ({ fields, meta: { touched, error } }) => {
        const { formatMessage } = this.props.intl;
        const { languageList } = this.props;
        const { selectedLanguages } = this.state;

        return (
            <div className={bt.languageBox}>
                {
                    fields && fields.map((category, index) => {
                        let fieldLength = fields.length - 1;
                        const currentLanguage = fields?.get(index)?.language;
                        const availableLanguages = languageList?.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);

                        return (
                            <div key={index}>
                                <Row>
                                    <Col lg={6} md={6} sm={12} xs={12} className={bt.mb12Xs}>
                                        <Field name={`${category}.language`} component={this.renderFormControlSelect} className={cx('noMargin', bt.formControlSelect, bt.formControlInput)} label={formatMessage(messages.language)}>
                                            <option value={''} >{formatMessage(messages.chooseLanguageLabel)}</option>
                                            {availableLanguages?.map((locale, index) => {
                                                return (
                                                    <option value={locale} key={index}>{formatLocale(locale)}</option>
                                                )
                                            })}
                                        </Field>
                                    </Col>
                                    <Col lg={6} md={6} sm={12} xs={12} className={bt.mb12Xs}>
                                        <Field name={`${category}.value`} type="text" component={this.renderField} label={formatMessage(messages.categoryTitle)} autoComplete={false} inputClassname={'noMargin'} />
                                    </Col>
                                </Row>
                                <div className={cx(bt.languageBtnContainer, 'darkLink', 'svgImg', { [bt.languageBtnContainerOne]: index != 0 })} >
                                    {(fields.length <= languageList?.length - 1) && fieldLength == index &&
                                        <Button className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")} onClick={() => fields.length <= languageList?.length - 1 && fields.push({})}>
                                            <img src={addIcon} alt='addIcon' />
                                            <span>	{formatMessage(messages.addLanguage)}</span>
                                        </Button>
                                    }

                                    {index != 0 && <div>
                                        <Button className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")} onClick={() => fields.remove(index)}>
                                            <img src={trashIcon} alt='addIcon' />
                                            <span>{formatMessage(messages.deleteLanguage)}</span>
                                        </Button>
                                    </div>}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    render() {
        const { handleSubmit } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding)}>
                <div className={s.responsiveNoPadding}>
                    <Card className={s.card}>
                        <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                            <h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>{formatMessage(messages.citySectionSettings)}</h1>
                            <Row>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <Form.Group className={cx(s.formGroup, 'noMargin')}>
                                        <div>
                                            <FieldArray name='citySectionTitle1' rerenderOnEveryChange={true} component={this.renderFieldArray} />
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className={cx(bt.textAlignRight, bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'textAlignLeftRTL')}>
                                    <Form.Group className={s.formGroup}>
                                        <Button
                                            type="submit"
                                            className={cx(bt.btnPrimary, bt.clickBtn)}
                                        >
                                            {formatMessage(messages.submitButton)}
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </div>
            </div>
        )
    }
}

const selector = formValueSelector('CitySettingsForm');

CitySettingsForm = reduxForm({
    form: 'CitySettingsForm',
    onSubmit: submit,
    validate
})(CitySettingsForm);

const mapState = (state) => ({
    languageList: state?.runtime?.availableLocales,
    dynamicCategoryTitle: selector(state, 'citySectionTitle1'),
});

const mapDispatch = {
}
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(CitySettingsForm)));
